var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Finder, FinderHeader, FinderTitle, FinderBody, NavPath, InboxModule, Schema } from "../";

import "./InboxEditor.scss";

import InboxEditorCompose from './InboxEditorCompose';
import InboxEditorParent from './InboxEditorParent';
import InboxEditorArray from './InboxEditorArray';
import InboxEditorChild from './InboxEditorChild';

var layouts = {
    "inbox-compose": InboxEditorCompose,
    "inbox-parent": InboxEditorParent,
    "inbox-array": InboxEditorArray,
    "inbox-child": InboxEditorChild
};

var InboxEditor = (_temp2 = _class = function (_Component) {
    _inherits(InboxEditor, _Component);

    function InboxEditor() {
        var _temp, _this, _ret;

        _classCallCheck(this, InboxEditor);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            preview: {},
            formData: {}
        }, _this.componentDidUpdate = function (prevProps, prevState) {

            if (prevProps.formData !== _this.props.formData) {
                _this.getFormData();
                _this.getFormContext();
            }
        }, _this.getFormData = function () {
            var _this$props = _this.props,
                user = _this$props.user,
                status = _this$props.status,
                formData = _this$props.formData;


            if (status === "new") {

                var from = user.name + " <" + user.email + ">";

                _this.setState({
                    formData: _extends({}, formData, {
                        messages: [{
                            from: from,
                            author: user
                        }]
                    })
                });

                return;
            }

            _this.setState({
                formData: formData
            });
        }, _this.getFormContext = function () {
            var _this$props2 = _this.props,
                user = _this$props2.user,
                formData = _this$props2.formData;


            var messages = formData.messages || [];

            var author = {
                id: user.id || undefined,
                uniqueId: user.uniqueId || undefined,
                name: user.name || undefined,
                imageUrl: user.imageUrl || undefined
            };

            var formContext = {
                author: user,
                messagesCount: messages.length,
                onDiscardDraft: _this.onDiscardDraft,
                onEditMessage: _this.onEditMessage,
                onSaveMessage: _this.onSaveMessage,
                onDeleteMessage: _this.onDeleteMessage,
                onSaveReply: _this.onSaveReply,
                onDiscardReply: _this.onDiscardReply
            };

            _this.setState({
                formContext: formContext
            });
        }, _this.onChange = function (props) {
            console.log('InboxEditor:onChange', props);

            var formData = props.formData;


            var messages = formData.messages || [];

            _this.setState({
                formData: formData,
                formContext: _extends({}, _this.state.formContext, {
                    messagesCount: messages.length
                })
            });

            if (_this.props.onChange) {
                _this.props.onChange(_this.state);
            }
        }, _this.onDiscardDraft = function (props) {
            console.log('InboxEditor:onDiscardDraft', props);

            if (_this.props.onDiscardDraft) {
                _this.props.onDiscardDraft(props);
            }
        }, _this.onEditMessage = function (props) {
            console.log('InboxEditor:onEditMessage', props);

            if (_this.props.onEditMessage) {
                _this.props.onEditMessage(props);
            }
        }, _this.onSaveMessage = function (props) {
            console.log('InboxEditor:onSaveMessage', props);

            if (_this.props.onSaveMessage) {
                _this.props.onSaveMessage(props);
            }
        }, _this.onDeleteMessage = function (props) {
            console.log('InboxEditor:onDeleteMessage', props);

            if (_this.props.onDeleteMessage) {
                _this.props.onDeleteMessage(props);
            }
        }, _this.onSaveReply = function (props) {
            console.log('InboxEditor:onSaveReply', props);

            if (_this.props.onSaveReply) {
                _this.props.onSaveReply(props);
            }
        }, _this.onDiscardReply = function (props) {
            console.log('InboxEditor:onDiscardReply', props);

            if (_this.props.onDiscardReply) {
                _this.props.onDiscardReply(props);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    InboxEditor.prototype.componentDidMount = function componentDidMount() {
        this.getFormData();
        this.getFormContext();
    };

    InboxEditor.prototype.render = function render() {
        var _props = this.props,
            status = _props.status,
            schema = _props.schema,
            uiSchema = _props.uiSchema,
            uiSchemaCompose = _props.uiSchemaCompose,
            user = _props.user;
        var _state = this.state,
            formData = _state.formData,
            formContext = _state.formContext;


        if (status === "new") {

            return React.createElement(Schema, { schema: schema, uiSchema: uiSchemaCompose, formData: formData, formContext: formContext, layouts: layouts, onChange: this.onChange, onSubmit: this.onSubmit });
        }

        return React.createElement(Schema, { schema: schema, uiSchema: uiSchema, formData: formData, formContext: formContext, layouts: layouts, onChange: this.onChange, onSubmit: this.onSubmit });
    };

    return InboxEditor;
}(Component), _class.defaultProps = {
    status: "",
    user: {},
    formData: {
        messages: []
    },
    schema: {
        type: "object",
        properties: {
            uniqueId: {
                type: "string",
                readonly: true
            },
            appName: {
                type: "string"
            },
            appColor: {
                type: "string"
            },
            ownerName: {
                type: "string"
            },
            inboxType: {
                type: "string",
                enum: ["message", "comments", "issue"],
                default: "message"
            },
            attachments: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        uniqueId: {
                            type: "string"
                        },
                        url: {
                            type: "string"
                        },
                        title: {
                            type: "string"
                        },
                        description: {
                            type: "string"
                        },
                        imageUrl: {
                            type: "string"
                        }
                    }
                }
            },
            messages: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        status: {
                            type: "string"
                        },
                        parentId: {
                            type: "string",
                            readonly: true
                        },
                        uniqueId: {
                            type: "string",
                            readonly: true
                        },
                        createdAt: {
                            type: "string"
                        },
                        updatedAt: {
                            type: "string"
                        },
                        author: {
                            type: "object",
                            properties: {
                                name: {
                                    type: "string"
                                },
                                email: {
                                    type: "string"
                                }
                            }
                        },
                        from: {
                            type: "string"
                        },
                        to: {
                            type: "string"
                        },
                        subject: {
                            type: "string"
                        },
                        message: {
                            type: "string"
                        }
                    }
                }
            }
        }
    },
    uiSchema: {
        "ui:layout": "inbox-parent",
        "ui:fieldset": ["messages"],
        "messages": {
            "ui:title": undefined,
            "ui:layout": "inbox-array",
            "ui:options": {
                "orderable": false
            },
            "ui:buttons": [{
                "label": "Reply",
                "item": {
                    "status": "reply"
                }
            }],
            "items": {
                "ui:layout": "inbox-child",
                "ui:options": {
                    "collapsible": true,
                    "editable": true
                },
                "ui:fieldset": ["message", "footer"],
                "message": {
                    "ui:widget": "textarea",
                    "ui:label": false
                },
                "ui:title": {
                    "select": "message"
                }
            }
        }
    },
    uiSchemaCompose: {
        "ui:layout": "inbox-parent",
        "uniqueId": {
            "ui:hidden": true
        },
        "messages": {
            "ui:title": undefined,
            "ui:layout": "inbox-array",
            "ui:options": {
                "orderable": false
            },
            "ui:buttons": [{
                "label": "Reply",
                "item": {
                    "status": "reply"
                }
            }],
            "items": {
                "ui:layout": "inbox-compose",
                "ui:options": {
                    "collapsible": true,
                    "editable": true
                },
                "ui:fieldset": ["from", "to", "subject", "message", "footer"],
                "message": {
                    "ui:widget": "textarea"
                },
                "ui:title": {
                    "select": "message"
                }
            }
        }
    }
}, _temp2);
InboxEditor.propTypes = process.env.NODE_ENV !== "production" ? {} : {};


export default InboxEditor;